import { render, staticRenderFns } from "./ValidarCartao.vue?vue&type=template&id=fd35be78&"
import script from "./ValidarCartao.vue?vue&type=script&lang=js&"
export * from "./ValidarCartao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports